import {Component, Input, OnInit} from '@angular/core';
import {TreeGroupPosService} from '../tree-group-pos.service';
import {AdminService} from '../../../../../services/admin.service';
import {AnswerGroupPos} from '../answer-group-pos.model';
import {StepsControllerService} from '../../../../../services/steps-controller.service';
import {Router} from '@angular/router';
import { UserService } from '../../../../../services/user.service';
import { User } from '../../../../../models/user.model';

@Component({
  selector: 'app-tree-group-pos-block',
  templateUrl: './tree-group-pos-block.component.html',
  styleUrls: ['./tree-group-pos-block.component.css']
})
export class TreeGroupPosBlockComponent implements OnInit {
  @Input() role: string = "";
  public isLoaded = false;
  public errorMsg = false;
  private foundGroup = false;
  private foundGroupExecute = false;
  private foundGroupExecuteOnlyConfirm = false;
  private foundGroupOnlyConfirm = false;
  private foundPosExecute = false;
  user: User;
  // Save here all Groups and Positions
  public allGroupsAndPositions: any[] = [];
  // Save here opened Groups
  private selectedGroups: AnswerGroupPos[] = [];
  // This array set to service and send to server
  private readeForServer: AnswerGroupPos[] = [];
  private readeForServerOnlyConfirm: AnswerGroupPos[] = [];

  // Use for show/hide Head/Deputy only confirms checkboxes
  public showOnlyConfirmCheckBox = false;

  constructor(private treeGroupPosService: TreeGroupPosService,
              private adminService: AdminService,
              private router: Router,
              private stepsControllerService: StepsControllerService,
              private userService: UserService) {
              // this.user = this.userService.getLocal();
              // if(this.role === 'ROLE_HEAD'){
              //   this.role = 'head';
              // }
  }

  ngOnInit() {
    this.isLoaded = false;
    this.errorMsg = false;

    // Clear arrays
    this.readeForServer = [];
    this.readeForServerOnlyConfirm = [];
    this.treeGroupPosService.clearPositionsForServerLists();

    if (this.router.url.includes('create-operating-standard')) {
      if (this.stepsControllerService.activeStep === 1 || this.stepsControllerService.activeStep === 2) {
        this.showOnlyConfirmCheckBox = true;
      }
    }

    // If standard was opened from any standards list
    if (this.stepsControllerService.hasCurrentStandard()) {
      // Check if standard has standard Dissemination Positions field
      if (this.stepsControllerService.getCurrentStandard().hasOwnProperty('groupsWithPositions')) {
        // If TRUE then initialize readeForServer
        if (this.stepsControllerService.getCurrentStandard().groupsWithPositions !== null) {
          if (this.stepsControllerService.getCurrentStandard().groupsWithPositions.length > 0) {
            this.stepsControllerService.getCurrentStandard().groupsWithPositions.forEach(item => {
              let isOnlyConfirm = false;
              if (item.hasOwnProperty('onlyHeadConfirm')) {
                isOnlyConfirm = item.onlyHeadConfirm;
              } else {
                // Set by default
                isOnlyConfirm = false;
              }
              const selectedGroup = new AnswerGroupPos(item.group.id, isOnlyConfirm);

              // if (item.positions.length > 0) {
                item.positions.forEach(pos => {
                  selectedGroup.addPos({id: pos.id});
                });
              // }

              // Add to ready for server
              if (!isOnlyConfirm) {
                this.readeForServer.push(selectedGroup);
              }

              // If selected for only confirm
              if (isOnlyConfirm) {
                this.readeForServerOnlyConfirm.push(selectedGroup);
              }

            });

          }
        }
        this.treeGroupPosService.setReadeForServer(this.readeForServer);
        this.treeGroupPosService.setReadeForServerOnlyConfirm(this.readeForServerOnlyConfirm);
      }
    }

    // GET ALL GROUPS WITH POSITIONS
    if(this.role === 'head') {
      this.adminService.getGroupsAndPositionsHead().subscribe(
        (res: any) => {
          if (res.status === 200) {
            this.allGroupsAndPositions = res.body;
            this.fieldsChangeGroupInit(true, this.allGroupsAndPositions[0]);
            if (this.readeForServer.length > 0) {
              for (const group of this.readeForServer) {
                for (const grp of this.allGroupsAndPositions) {
                  if (grp.id === group.id) {
                    this.selectedGroups.push(grp);
                  }
                }
              }
            }
            this.errorMsg = false;
          } else {
            this.errorMsg = true;
          }
          this.isLoaded = true;
        },
        (err) => {
          this.errorMsg = true;
          this.isLoaded = true;
        }
      );
    } else {
      this.adminService.getGroupsAndPositions().subscribe(
        (res: any) => {
          if (res.status === 200) {
            this.allGroupsAndPositions = res.body;
            if (this.readeForServer.length > 0) {
              for (const group of this.readeForServer) {
                for (const grp of this.allGroupsAndPositions) {
                  if (grp.id === group.id) {
                    this.selectedGroups.push(grp);
                  }
                }
              }
            }
            this.errorMsg = false;
          } else {
            this.errorMsg = true;
          }
          this.isLoaded = true;
        },
        (err) => {
          this.errorMsg = true;
          this.isLoaded = true;
        }
      );
    }
  }

  // Check if group is opened
  isSelectedGroup(group) {
    this.foundGroup = false;
    if (this.selectedGroups.length > 0) {
      for (const grp of this.selectedGroups) {
        if (grp.id === group.id) {
          this.foundGroup = true;
          break;
        }
      }
    }
    return this.foundGroup;
  }

  // Open/close groups positions list
  selectGroupItem(group) {
    // If group is opened
    if (this.isSelectedGroup(group)) {
      // If group is unchecked
      if (!this.isSelectedGroupExecute(group)) {
        const index = this.selectedGroups.findIndex(x => x.id === group.id);
        if (index !== -1) {
          this.selectedGroups.splice(index, 1);
        }
      }
    } else {
      this.selectedGroups.push(group);
    }
  }

  // Check if group checkbox is checked
  isSelectedGroupExecute(group) {
    this.foundGroupExecute = false;
    if (this.readeForServer.length > 0) {
      for (const grp of this.readeForServer) {

        if (grp.id === group.id && !grp.onlyHeadConfirm) {
          if (grp.positions.length > 0) {
            for (const grpPos of  grp.positions) {
              if (this.isSelectedPosExecute(grpPos, grp)) {
                this.foundGroupExecute = true;
                break;
              }
            }
          }
          break;
        }
      }
    }
    return this.foundGroupExecute;
  }

  // Check if group checkbox is checked
  isSelectedGroupExecuteOne(group) {
    this.foundGroupExecute = false;
    if (this.readeForServer.length > 0) {
      for (const grp of this.readeForServer) {
        if (grp.id === group.id) {
          this.foundGroupExecute = true;
          break;
        }
      }
    }
    return this.foundGroupExecute;
  }

  // Check if group checkbox is checked for confirm
  isSelectedGroupOnlyConfirm(group) {
    this.foundGroupExecuteOnlyConfirm = false;
    if (this.readeForServerOnlyConfirm.length > 0) {
      for (const grp of this.readeForServerOnlyConfirm) {
        if (grp.id === group.id) {
          this.foundGroupExecuteOnlyConfirm = true;
          break;
        }
      }
    }
    return this.foundGroupExecuteOnlyConfirm;
  }

  // Checkbox actions on/off group
  fieldsChangeGroup(values: any, group) { // JUST
    if (values.currentTarget.checked) {
      // CHECK
      if (!this.isSelectedGroupExecute(group)) {
        const selectedGroup = new AnswerGroupPos(group.id, group.onlyHeadConfirm);
  
        for (const pos of group.positions) {
          selectedGroup.addPos({id: pos.id});
        }
        // Add to ready for server
        this.readeForServer.push(selectedGroup);
        this.treeGroupPosService.setReadeForServer(this.readeForServer);
      }
      // Open group if group is closed
      if (!this.isSelectedGroup(group)) {
        this.selectGroupItem(group);
      }

    } else {
      // UNCHECK
      if (this.isSelectedGroupExecute(group)) {
        // Remove from ready for server
        const index = this.readeForServer.findIndex(x => x.id === group.id);
        if (index !== -1) {
          this.readeForServer.splice(index, 1);
          this.treeGroupPosService.setReadeForServer(this.readeForServer);
        }
      }
    }
  }

  fieldsChangeGroupInit(a, group) { // JUST
    if (a) {
      // CHECK
      if (!this.isSelectedGroupExecute(group)) {
        const selectedGroup = new AnswerGroupPos(group.id, group.onlyHeadConfirm);
        for (const pos of group.positions) {
          selectedGroup.addPos({id: pos.id});
        }
        // Add to ready for server
        this.readeForServer.push(selectedGroup);
        this.treeGroupPosService.setReadeForServer(this.readeForServer);
      }
      // Open group if group is closed
      if (!this.isSelectedGroup(group)) {
        this.selectGroupItem(group);
      }
    } else {
      // UNCHECK
      if (this.isSelectedGroupExecute(group)) {
        // Remove from ready for server
        const index = this.readeForServer.findIndex(x => x.id === group.id);
        if (index !== -1) {
          this.readeForServer.splice(index, 1);
          this.treeGroupPosService.setReadeForServer(this.readeForServer);
        }
      }
    }
  }

  // Checkbox actions on/off group
  fieldsChangeGroupOnlyConfirm(values: any, group) { // CONFIRM
    if (values.currentTarget.checked) {
      // CHECKнул
      group.onlyHeadConfirm = true;
      if (!this.isSelectedGroupOnlyConfirm(group)) {
        const selectedGroup = new AnswerGroupPos(group.id, group.onlyHeadConfirm);
        for (const pos of group.positions) {
          selectedGroup.addPos({id: pos.id});
        }
        // Add to ready for server
        this.readeForServerOnlyConfirm.push(selectedGroup);
        this.treeGroupPosService.setReadeForServerOnlyConfirm(this.readeForServerOnlyConfirm);
      }
      // Open group if group is closed
      if (!this.isSelectedGroup(group)) {
        this.selectGroupItem(group);
      }
    } else {
      // UNCHECKнул
      group.onlyHeadConfirm = false;
      if (this.isSelectedGroupOnlyConfirm(group)) {
        // Remove from ready for server
        const index = this.readeForServerOnlyConfirm.findIndex(x => x.id === group.id);
        if (index !== -1) {
          this.readeForServerOnlyConfirm.splice(index, 1);
          this.treeGroupPosService.setReadeForServerOnlyConfirm(this.readeForServerOnlyConfirm);
        }
      }
    }
  }

  // Check if position checkbox is checked
  isSelectedPosExecute(pos, group) {
    this.foundPosExecute = false;
    if (this.readeForServer.length > 0) {
      // Get all positions of this group and check this pos
      const index = this.readeForServer.findIndex(x => x.id === group.id);
      if (index !== -1) {
        for (const ps of this.readeForServer[index].positions) {
          if (ps.id === pos.id) {
            this.foundPosExecute = true;
            break;
          }
        }
      }
    }
    return this.foundPosExecute;
  }

  // Checkbox actions on/off position
  fieldsChangePos(values: any, pos, group) {
    if (values.currentTarget.checked) {
      // CHECK
      // If group is checked
      if (this.isSelectedGroupExecuteOne(group)) {
        // If pos is unchecked
        if (!this.isSelectedPosExecute(pos, group)) {
          // Get all positions of this group and check this pos
          const index = this.readeForServer.findIndex(x => x.id === group.id);
          if (index !== -1) {
            this.readeForServer[index].positions.push({id: pos.id});
          }
        }
      } else {
        const selectedGroup = new AnswerGroupPos(group.id, group.onlyHeadConfirm);
        selectedGroup.addPos({id: pos.id});
        this.readeForServer.push(selectedGroup);
        this.treeGroupPosService.setReadeForServer(this.readeForServer);
      }

    } else {
      // UNCHECK
      // If pos was checked
      if (this.isSelectedPosExecute(pos, group)) {
        // Finding group
        const index = this.readeForServer.findIndex(x => x.id === group.id);
        if (index !== -1) {
          // Remove pos from selected group
          const posIndex = this.readeForServer[index].positions.findIndex(x => x.id === pos.id);

          if (posIndex !== -1) {
            this.readeForServer[index].positions.splice(posIndex, 1);
            // Удалить группу, если нет выбранных позиций
            if (this.readeForServer[index].positions.length <= 0) {
              this.readeForServer.splice(index, 1);
              this.treeGroupPosService.setReadeForServer(this.readeForServer);
            }
            this.treeGroupPosService.setReadeForServer(this.readeForServer);
          }
        }
      }
    }

    // Uncheck group if all positions are unchecked
    // Get group if group is checked
    if (this.isSelectedGroupExecute(group)) {
      // Get positions of this group
      const index = this.readeForServer.findIndex(x => x.id === group.id);
      if (index !== -1) {
        // Remove group from ready for server if position list is empty
        if (this.readeForServer[index].positions.length === 0) {
          this.readeForServer.splice(index, 1);
          this.treeGroupPosService.setReadeForServer(this.readeForServer);
        }
      }
    }

  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-operating-standard/tree-group-pos-service/tree-group-pos-block/tree-group-pos-block.component.ts